<a
  [routerLink]="link()"
  routerLinkActive="active"
  #rla="routerLinkActive"
  [attr.aria-current]="rla.isActive ? 'page' : null"
  [attr.aria-label]="icon() ? (label() | translate) : null"
>
  @if (icon()) {
    <span
      class="icon"
      aria-hidden="true"
      [inlineSVG]="icon()"
    ></span>
  } @else {
    {{ label() | translate }}
  }
  @if (badgeCount() > 0) {
    <span
      class="badge"
      [attr.aria-label]="badgeCount() + ' ' + (badgeLabel() | translate)"
    >
      {{ badgeCount() > 99 ? 99 : badgeCount() }}
    </span>
  }
</a>
